import styled from 'styled-components';
import { colors } from 'styles/colors';

export const MonthInputContainer = styled.div`
  display: flex;
  flex-direction: column;

  & > div {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;
  }

  & > span {
    font-weight: 400;
    font-size: 11px;
    line-height: 180%;
    color: ${colors.text['sub-500']};
  }
`;

export const MeasureUnitIndicatorContainer = styled.div`
  width: 26px;
  height: 24px;
  border-radius: 4px;
  background-color: ${colors.bg['soft-200']};
  display: flex;
  align-items: center;
  justify-content: center;

  span {
    text-align: center;
    font-weight: 500;
    color: ${colors.text['sub-500']};
    font-size: 10px;
    line-height: 130%;
  }
`;
